// icon:subtitles | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

function IconSubtitles(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2M4 12h4v2H4v-2m10 6H4v-2h10v2m6 0h-4v-2h4v2m0-4H10v-2h10v2z" />
    </svg>
  );
}

export default IconSubtitles;
